import { useState } from "react";
import { PENDAHULUAN, isiAngka, pecahTebal } from "@/lib/survei";

// Teks pendahuluan /survei. Desktop (md:): seluruh P1-P7 berurutan. HP: hanya paragraf `inti` (sapaan, anonimitas,
// cara pengisian + peringatan "jawaban sementara tidak tersimpan") yg selalu tampil; sisanya terlipat di balik tombol
// "Baca petunjuk lengkap" (urutan asli tetap) supaya kolom NPM & tanggal lahir tidak terdorong jauh ke bawah.
// Teks dirender sbg elemen React (bukan HTML mentah); baris baru di dalam paragraf (kontak) lewat whitespace-pre-line.
// Rata kiri-kanan (justify) utk paragraf isi; lang="id" + hyphens:auto (dgn awalan Safari) supaya browser boleh memenggal
// kata dan celah antarkata tidak melebar di layar HP. Tetap rata kiri: P1 (sapaan dua baris pendek; justify menyebar
// spasinya dan tampak janggal) dan P7 (blok penutup nama/alamat/unit/kontak, baris pendek-pendek) -- isi teks & urutan
// tidak berubah. Catatan (diukur Okt 2026): hyphens:auto nyaris tidak memenggal kata Indonesia di Chromium, jadi di
// layar sempit celah antarkata di P2-P6 tetap bisa melebar (sampai ~25px pada 360-390px).
// `angka` = angkaPendahuluan(butir) dari versi butir periode: jumlah pernyataan, bagian, skala, isian terbuka (P5).
export const RATA_KIRI = new Set(["p1", "p7"]);
export const KELAS_JUSTIFY = "text-justify hyphens-auto [-webkit-hyphens:auto]";

// `paragraf` = PENDAHULUAN (Kedokteran, bawaan) atau PENDAHULUAN_KEPNAKES.
export default function SurveiPendahuluan({ angka, paragraf = PENDAHULUAN }) {
    const [terbuka, setTerbuka] = useState(false);
    return (
        <div id="survei-pengantar" lang="id" className="space-y-3 text-sm leading-relaxed text-foreground" data-testid="survei-pengantar">
            {paragraf.map((p) => (
                <p
                    key={p.id}
                    data-testid={`survei-${p.id}`}
                    className={`whitespace-pre-line ${RATA_KIRI.has(p.id) ? "text-left" : KELAS_JUSTIFY} ${p.inti || terbuka ? "" : "hidden md:block"}`}
                >
                    {pecahTebal(isiAngka(p.teks, angka)).map((b, i) => (b.tebal ? <strong key={i}>{b.teks}</strong> : <span key={i}>{b.teks}</span>))}
                </p>
            ))}
            <button
                type="button"
                onClick={() => setTerbuka((t) => !t)}
                aria-expanded={terbuka}
                aria-controls="survei-pengantar"
                data-testid="survei-baca-lengkap"
                className="flex min-h-11 w-full items-center justify-center rounded-xl border border-border px-4 text-sm font-semibold text-[color:var(--brand-turq-text)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground md:hidden"
            >
                {terbuka ? "Sembunyikan petunjuk lengkap" : "Baca petunjuk lengkap"}
            </button>
        </div>
    );
}
